import { Axios } from "../../../Api/axios";

// Marketplace money — backend: AdminMarketRevenueController.
// Optional { from, to } (YYYY-MM-DD); without them everything is all-time.

const clean = (params = {}) =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export const getMarketRevenue = (params) =>
  Axios.get("/market/revenue", { params: clean(params) }).then((r) => r.data);

export const getMarketRevenueStores = (params) =>
  Axios.get("/market/revenue/stores", { params: clean(params) }).then((r) => r.data);

export const getStoreWalletTransactions = (id, params) =>
  Axios.get(`/market/stores/${id}/wallet-transactions`, { params: clean(params) }).then((r) => r.data);

export const updateDefaultCommission = (rate) =>
  Axios.put("/market/commission-rate", { rate }).then((r) => r.data);

// rate = null → the store goes back to the default.
export const updateStoreCommission = (id, rate) =>
  Axios.put(`/market/stores/${id}/commission-rate`, { rate }).then((r) => r.data);
